import { useEffect, useRef, useState } from 'react';
import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { Icon as IconBase } from '@hotjar/webapp/components/Icon';
import { tokens } from '@hotjar/hotsauce';
import { useTranslation } from '@hotjar/translations';

const RESET_CONFIRM_TIMEOUT_MS = 1200;

const Icon = styled(IconBase)`
  margin-right: 8px;
  padding: 3px;
  background: ${tokens.color.mint_600};
  border-radius: 50%;
`;
const boxAnimation = css`
  @keyframes confirmation-slide {
    0% {
      transform: translateY(0);
    }
    10% {
      transform: translateY(100px);
    }
    90% {
      transform: translateY(100px);
    }
    100% {
      transform: translateY(0);
    }
  }

  animation: confirmation-slide ${RESET_CONFIRM_TIMEOUT_MS}ms;
  opacity: 1;
`;
const MessageBox = styled('div')`
  opacity: 0;
  position: absolute;
  top: -40px;
  left: calc(50% - 58px);
  z-index: 2;
  background: rgba(0, 0, 0, 0.1);
  color: black;
  text-align: center;
  padding: 10px;
  font-size: 11px;
  border-radius: 2px;
`;

interface ResetConfirmationProps {
  isVisible: boolean;
}

export const ResetConfirmation = ({ isVisible }: ResetConfirmationProps): JSX.Element => {
  const { t } = useTranslation('feedback');
  const [showMsg, setShowMsg] = useState(false);
  const timeout = useRef<NodeJS.Timeout>();

  if (isVisible && !showMsg) {
    setShowMsg(true);
    timeout.current = setTimeout(() => setShowMsg(false), RESET_CONFIRM_TIMEOUT_MS);
  }

  useEffect(() => {
    return () => {
      if (timeout.current !== undefined) clearTimeout(timeout.current);
    };
  }, []);

  return (
    <MessageBox css={showMsg && boxAnimation}>
      <Icon icon="check" size={16} color={tokens.color.text_default_inverse} />{' '}
      {t('wizard.preview.reset-confirmation')}
    </MessageBox>
  );
};
